// extracted by mini-css-extract-plugin
export var container = "index-module--container--qu2ph";
export var description = "index-module--description--3yrTD";
export var descriptionContainer = "index-module--descriptionContainer--1aJYL";
export var image = "index-module--image--3tqID";
export var form = "index-module--form--2dcpW";
export var servicePointContainer = "index-module--servicePointContainer--1yiXC";